export enum USER_ROLE {
  ADMIN = 'admin',
  USER = 'user',
  BUYER = 'buyer',
  SELLER = 'seller',
  SELLER_AGENT = 'seller_agent',
}

export const userRoles = [
  {
    value: USER_ROLE.ADMIN,
    label: 'Admin',
  },
  {
    value: USER_ROLE.USER,
    label: 'User',
  },
  {
    value: USER_ROLE.BUYER,
    label: 'Buyer',
  },
  {
    value: USER_ROLE.SELLER,
    label: 'Seller',
  },
  {
    value: USER_ROLE.SELLER_AGENT,
    label: 'Seller Agent',
  },
];

export enum USER_APPROVE_STATUS {
  NOT_SUBMITTED = 'not_submitted',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}
export enum USER_QUALIFY_STATUS {
  INITIAL = 'initial',
  QUALIFY = 'qualify',
}

export enum CONTRACT_BUYER_STEP {
  BUYER_INFO = 0,
  OFFER_INFO = 1,
  THIRD_PARTY = 2,
  TIMELINE = 3,
  REVIEW = 4,
  NEGOTIATION = 5,
  COMPLETED = 6,
}
export const NumberOfBuyers = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
];

export const contractBuyerSteps = [
  'Buyer Information',
  'Offer Information',
  'Third Parties',
  'Timeline',
  'Review',
  'Negotiation',
];

export enum CONTRACT_AGENT_STEP {
  AGENT_INFO = 0,
  SELLER_INFO = 1,
  REVIEW = 2,
  COMPLETED = 3,
}
export const contractAgentSteps = [
  'Agent Information',
  'Seller Information',
  'Review',
];

export enum CONTRACT_SELLER_STEP {
  SELLER_INFO = 0,
  PROPERTY_DISCLOSURES = 1,
  PROPERTY_INFO = 2,
  REVIEW = 3,
  COMPLETED = 4,
}
export const contractSellerSteps = [
  'Seller Information',
  'Property Disclosures',
  'Seller Property Information',
  'Review',
];
export enum OFFER_TYPE {
  CASH = 'cash',
  FINANCED = 'financed',
}
export const typeOfOffers = [
  {
    label: 'Cash ',
    value: 'Cash',
  },
  {
    label: 'Financed',
    value: 'Financed',
  },
];

export enum SELLER_ASSISTANCE_TYPE {
  SELLER_TO_PAY_BUYER_AGENT_FEE_ADDITIONAL_SELLER_CREDIT = 'Seller to pay Buyer Agent Fee + Additional Seller Credit',
  SELLER_CREDIT_EQUALS_BUYER_AGENT_FEE = 'Seller credit equals Buyer Agent Fee',
  SELLER_TO_PAY_UNBEATABLE_FEE = 'Seller to pay Unbeatable Fee',
  NO_SELLER_ASSISTANCE = 'No Seller Assistance',
}
export const sellerAssistanceTypes = [
  {
    label: 'Seller to pay Buyer Agent Fee + Additional Seller Credit',
    value: 'Seller to pay Buyer Agent Fee + Additional Seller Credit',
  },
  {
    label: 'Seller credit equals Buyer Agent Fee',
    value: 'Seller credit equals Buyer Agent Fee',
  },
  {
    label: 'Seller to pay Unbeatable Fee',
    value: 'Seller to pay Unbeatable Fee',
  },
  {
    label: 'No Seller Assistance',
    value: 'No Seller Assistance',
  },
];

export const numberOfMoneyDeposits = [
  {
    label: '0',
    value: 0,
  },
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
];

export enum USER_OCCUPANCY {
  DEFAULT = 'default',
  PRIMARY_RESIDENCE = 'primary_residence',
  SECONDARY_RESIDENCE = 'secondary_residence',
  INVESTMENT_PROPERTY = 'investment_property',
}
export const userOccupancys = [
  {
    label: 'Default',
    value: USER_OCCUPANCY.DEFAULT,
  },
  {
    label: 'Primary Residence',
    value: USER_OCCUPANCY.PRIMARY_RESIDENCE,
  },
  {
    label: 'Secondary Residence',
    value: USER_OCCUPANCY.SECONDARY_RESIDENCE,
  },
  {
    label: 'Investment Property',
    value: USER_OCCUPANCY.INVESTMENT_PROPERTY,
  },
];
export const InspectionTypes = [
  {
    label: 'Just General HomeOwners Inspection',
    value: 'Just General HomeOwners Inspection',
  },
  {
    label: 'Additional Inspection Required',
    value: 'Additional Inspection Required',
  },
];

export enum ADDITIONAL_PROPERTY_INSPECTION_TYPE {
  NO_ADDITIONAL_INSPECTION_REQUIRED = 'No Additional Inspection Required',
  WATER = 'Water',
  SEWER = 'Sewer',
  ROOF = 'Roof',
  INSECTS = 'Insects',
  STRUCTURAL = 'Structural',
  ENVIRONMENTAL = 'Environmental',
  RADON = 'Radon',
  MOLD = 'Mold',
  LEAD_BASED_PAINT = 'Lead Based Paint',
  ASBESTOS = 'Asbestos',
  ELECTRICAL = 'Electrical',
  HVAC = 'HVAC',
  POOL = 'Pool',
}
export const AdditionalPropertyInspectionTypes = [
  {
    label: 'No Additional Inspection Required',
    value: 'No Additional Inspection Required',
  },
  {
    label: 'Water',
    value: 'Water',
  },
  {
    label: 'Sewer',
    value: 'Sewer',
  },
  {
    label: 'Roof',
    value: 'Roof',
  },
  {
    label: 'Insects',
    value: 'Insects',
  },
  {
    label: 'Structural',
    value: 'Structural',
  },
  {
    label: 'Environmental',
    value: 'Environmental',
  },
  {
    label: 'Radon',
    value: 'Radon',
  },
  {
    label: 'Mold',
    value: 'Mold',
  },
  {
    label: 'Lead Based Paint',
    value: 'Lead Based Paint',
  },
  {
    label: 'Asbestos',
    value: 'Asbestos',
  },
  {
    label: 'Electrical',
    value: 'Electrical',
  },
  {
    label: 'HVAC',
    value: 'HVAC',
  },
  {
    label: 'Pool',
    value: 'Pool',
  },
];
export const userOccupancyMap = {
  [USER_OCCUPANCY.DEFAULT]: 'Default',
  [USER_OCCUPANCY.PRIMARY_RESIDENCE]: 'Primary Residence',
  [USER_OCCUPANCY.SECONDARY_RESIDENCE]: 'Secondary Residence',
  [USER_OCCUPANCY.INVESTMENT_PROPERTY]: 'Investment Property',
};

export enum USER_LOAN_PROGRAM_TYPE {
  CONVENTIONAL = 'conventional',
  UNBEATABLE_LOAN = 'unbeatable_loan',
  FHA = 'fha',
  VA = 'va',
  USDA = 'usda',
  COMMERCIAL = 'commercial',
  CASH = 'cash',
  PRIVATE_FINANCING = 'private_financing',
  OTHER = 'other',
}
export const userLoanProgramTypes = [
  {
    label: 'Conventional',
    value: USER_LOAN_PROGRAM_TYPE.CONVENTIONAL,
  },
  {
    label: 'Unbeatable Loan',
    value: USER_LOAN_PROGRAM_TYPE.UNBEATABLE_LOAN,
  },
  {
    label: 'FHA',
    value: USER_LOAN_PROGRAM_TYPE.FHA,
  },
  {
    label: 'VA',
    value: USER_LOAN_PROGRAM_TYPE.VA,
  },
  {
    label: 'USDA',
    value: USER_LOAN_PROGRAM_TYPE.USDA,
  },
  {
    label: 'Commercial',
    value: USER_LOAN_PROGRAM_TYPE.COMMERCIAL,
  },
  {
    label: 'Cash',
    value: USER_LOAN_PROGRAM_TYPE.CASH,
  },
  {
    label: 'Private Financing',
    value: USER_LOAN_PROGRAM_TYPE.PRIVATE_FINANCING,
  },
  {
    label: 'Other',
    value: USER_LOAN_PROGRAM_TYPE.OTHER,
  },
];

export enum USER_LOAN_ESTIMATION_TYPE {
  INVESTOR = 'investor',
  HOME_BUYER = 'home_buyer',
  REFINANCE = 'refinance',
  COMMERCIAL = 'commercial',
}
export const userLoanEstimationTypes = [
  {
    label: 'Investor',
    value: USER_LOAN_ESTIMATION_TYPE.INVESTOR,
  },
  {
    label: 'Home Buyer',
    value: USER_LOAN_ESTIMATION_TYPE.HOME_BUYER,
  },
  {
    label: 'Refinance',
    value: USER_LOAN_ESTIMATION_TYPE.REFINANCE,
  },
  {
    label: 'Commercial',
    value: USER_LOAN_ESTIMATION_TYPE.COMMERCIAL,
  },
];
export const userLoanEstimationTypeMap = {
  [USER_LOAN_ESTIMATION_TYPE.INVESTOR]: 'Investor',
  [USER_LOAN_ESTIMATION_TYPE.HOME_BUYER]: 'Home Buyer',
  [USER_LOAN_ESTIMATION_TYPE.REFINANCE]: 'Refinance',
  [USER_LOAN_ESTIMATION_TYPE.COMMERCIAL]: 'Commercial',
};

export enum USER_LOAN_PROGRAM {
  DEFAULT = 'default',
  DSCR = 'dscr',
  FHA = 'fha',
  FIX_AND_FLIP = 'fix_and_flip',
  USDA = 'usda',
  VA = 'va',
  CONVENTIONAL = 'conventional',
  CASH = 'cash',
  COMMERCIAL = 'commercial',
  BRIDGE = 'bridge',
  HELOC = 'heloc',
  HELOAN = 'heloan',
  SECOND_MORTGAGE = 'second_mortgage',
}
export const userLoanPrograms = [
  {
    label: 'Default',
    value: USER_LOAN_PROGRAM.DEFAULT,
  },
  {
    label: 'DSCR',
    value: USER_LOAN_PROGRAM.DSCR,
  },
  {
    label: 'FHA',
    value: USER_LOAN_PROGRAM.FHA,
  },
  {
    label: 'Fix and Flip',
    value: USER_LOAN_PROGRAM.FIX_AND_FLIP,
  },
  {
    label: 'USDA',
    value: USER_LOAN_PROGRAM.USDA,
  },
  {
    label: 'VA',
    value: USER_LOAN_PROGRAM.VA,
  },
  {
    label: 'Conventional',
    value: USER_LOAN_PROGRAM.CONVENTIONAL,
  },
  {
    label: 'Bridge',
    value: USER_LOAN_PROGRAM.BRIDGE,
  },
  {
    label: 'HELOC',
    value: USER_LOAN_PROGRAM.HELOC,
  },
  {
    label: 'HELOAN',
    value: USER_LOAN_PROGRAM.HELOAN,
  },
  {
    label: '2nd Mortgage',
    value: USER_LOAN_PROGRAM.SECOND_MORTGAGE,
  },
];
export const userLoanProgramMap = {
  [USER_LOAN_PROGRAM.DEFAULT]: 'Default',
  [USER_LOAN_PROGRAM.DSCR]: 'DSCR',
  [USER_LOAN_PROGRAM.FHA]: 'FHA',
  [USER_LOAN_PROGRAM.FIX_AND_FLIP]: 'Fix and Flip',
  [USER_LOAN_PROGRAM.USDA]: 'USDA',
  [USER_LOAN_PROGRAM.VA]: 'VA',
  [USER_LOAN_PROGRAM.CONVENTIONAL]: 'Conventional',
  [USER_LOAN_PROGRAM.CASH]: 'Cash Offer',
  [USER_LOAN_PROGRAM.COMMERCIAL]: 'Commercial',
  [USER_LOAN_PROGRAM.BRIDGE]: 'Bridge',
  [USER_LOAN_PROGRAM.HELOC]: 'HELOC',
  [USER_LOAN_PROGRAM.HELOAN]: 'HELOAN',
  [USER_LOAN_PROGRAM.SECOND_MORTGAGE]: '2nd Mortgage',
};

/** Equity products only valid for refinance flows, not purchase estimates. */
export const REFINANCE_ONLY_LOAN_PROGRAMS: readonly USER_LOAN_PROGRAM[] = [
  USER_LOAN_PROGRAM.HELOC,
  USER_LOAN_PROGRAM.HELOAN,
  USER_LOAN_PROGRAM.SECOND_MORTGAGE,
];

// Helper function to get loan programs based on mode and investor status
export const getLoanProgramsForMode = (
  mode: 'purchase' | 'refinance',
  isInvestor: boolean = false
) => {
  const basePrograms = {
    purchase: [
      USER_LOAN_PROGRAM.DEFAULT,
      USER_LOAN_PROGRAM.CONVENTIONAL,
      USER_LOAN_PROGRAM.FHA,
      USER_LOAN_PROGRAM.VA,
      USER_LOAN_PROGRAM.USDA,
      USER_LOAN_PROGRAM.CASH,
    ],
    refinance: [
      USER_LOAN_PROGRAM.DEFAULT,
      USER_LOAN_PROGRAM.CONVENTIONAL,
      USER_LOAN_PROGRAM.FHA,
      USER_LOAN_PROGRAM.VA,
      USER_LOAN_PROGRAM.USDA,
      USER_LOAN_PROGRAM.HELOC,
      USER_LOAN_PROGRAM.HELOAN,
      USER_LOAN_PROGRAM.SECOND_MORTGAGE,
    ],
  };

  const investorPrograms = [
    USER_LOAN_PROGRAM.DSCR,
    USER_LOAN_PROGRAM.FIX_AND_FLIP,
    USER_LOAN_PROGRAM.COMMERCIAL,
    USER_LOAN_PROGRAM.BRIDGE,
  ];

  const baseProgramsForMode = basePrograms[mode];

  if (isInvestor) {
    return [...baseProgramsForMode, ...investorPrograms];
  }

  return baseProgramsForMode;
};

export function pickDefaultLoanProgram(
  allowed: USER_LOAN_PROGRAM[]
): USER_LOAN_PROGRAM {
  if (allowed.includes(USER_LOAN_PROGRAM.CONVENTIONAL)) {
    return USER_LOAN_PROGRAM.CONVENTIONAL;
  }
  return allowed[0] ?? USER_LOAN_PROGRAM.CONVENTIONAL;
}

/** Coerce saved/legacy program to one allowed for the given mode + investor access. */
export function normalizeLoanProgramForMode(
  program: string | undefined,
  mode: 'purchase' | 'refinance',
  isInvestor: boolean
): USER_LOAN_PROGRAM {
  const allowed = getLoanProgramsForMode(mode, isInvestor);
  const p = program as USER_LOAN_PROGRAM;
  if (p && allowed.includes(p)) return p;
  return pickDefaultLoanProgram(allowed);
}

export const USER_LOAN_ESTIMATION_DICT = {
  [USER_LOAN_ESTIMATION_TYPE.INVESTOR]: {
    LOAN_PROGRAMS: [
      USER_LOAN_PROGRAM.DEFAULT,
      USER_LOAN_PROGRAM.DSCR,
      USER_LOAN_PROGRAM.FIX_AND_FLIP,
      USER_LOAN_PROGRAM.CONVENTIONAL,
      USER_LOAN_PROGRAM.COMMERCIAL,
      USER_LOAN_PROGRAM.BRIDGE,
    ],
    OCCUPANCY: [USER_OCCUPANCY.INVESTMENT_PROPERTY],
  },
  [USER_LOAN_ESTIMATION_TYPE.HOME_BUYER]: {
    LOAN_PROGRAMS: [
      USER_LOAN_PROGRAM.DEFAULT,
      USER_LOAN_PROGRAM.USDA,
      USER_LOAN_PROGRAM.VA,
      USER_LOAN_PROGRAM.CONVENTIONAL,
      USER_LOAN_PROGRAM.FHA,
      USER_LOAN_PROGRAM.CASH,
    ],
    OCCUPANCY: [
      USER_OCCUPANCY.PRIMARY_RESIDENCE,
      USER_OCCUPANCY.SECONDARY_RESIDENCE,
      USER_OCCUPANCY.INVESTMENT_PROPERTY,
    ],
  },
  [USER_LOAN_ESTIMATION_TYPE.REFINANCE]: {
    LOAN_PROGRAMS: [
      USER_LOAN_PROGRAM.DEFAULT,
      USER_LOAN_PROGRAM.CONVENTIONAL,
      USER_LOAN_PROGRAM.FHA,
      USER_LOAN_PROGRAM.VA,
      USER_LOAN_PROGRAM.USDA,
      USER_LOAN_PROGRAM.HELOC,
      USER_LOAN_PROGRAM.HELOAN,
      USER_LOAN_PROGRAM.SECOND_MORTGAGE,
    ],
    OCCUPANCY: Object.values(USER_OCCUPANCY),
  },
  [USER_LOAN_ESTIMATION_TYPE.COMMERCIAL]: {
    LOAN_PROGRAMS: [USER_LOAN_PROGRAM.DEFAULT],
    OCCUPANCY: [USER_OCCUPANCY.INVESTMENT_PROPERTY],
  },
};

export const userApproveStatuses = [
  {
    value: USER_APPROVE_STATUS.NOT_SUBMITTED,
    label: 'Not Submitted',
  },
  {
    value: USER_APPROVE_STATUS.APPROVED,
    label: 'Approved',
  },
  {
    value: USER_APPROVE_STATUS.REJECTED,
    label: 'Rejected',
  },
  {
    value: USER_APPROVE_STATUS.PENDING,
    label: 'Pending',
  },
];

// Contract
export enum CONTRACT_APPRAISAL_CONTINGENCY {
  AT_LEAST_PURCHASE_PRICE = 'at_least_purchase_price',
  AT_LEAST_LISTING_PRICE = 'at_least_listing_price',
  AT_LEST_WITHIN_RANGE = 'at_least_within_range',
  NONE = 'none',
  SELECTED = 'selected',
  NOT_SELECTED = '',
}
export const contractAppraisalContingencies = [
  {
    value: CONTRACT_APPRAISAL_CONTINGENCY.AT_LEAST_PURCHASE_PRICE,
    label: 'At least Purchase Price',
  },
  {
    value: CONTRACT_APPRAISAL_CONTINGENCY.AT_LEAST_LISTING_PRICE,
    label: 'At least Listing Price',
  },
  {
    value: CONTRACT_APPRAISAL_CONTINGENCY.AT_LEST_WITHIN_RANGE,
    label: 'At least within the range of Purchase Price - Down payment',
  },
  {
    value: CONTRACT_APPRAISAL_CONTINGENCY.NONE,
    label: 'No Appraisal Contingency',
  },
];

export enum CONTRACT_FINANCING_CONTINGENCY {
  AT_LEAST_PURCHASE_PRICE = 'at_least_purchase_price',
  TIMELINE = 'timeline',
  SELECTED = 'selected',
  NOT_SELECTED = '',
}

export const contractFinancingContingencies = [
  {
    value: CONTRACT_FINANCING_CONTINGENCY.AT_LEAST_PURCHASE_PRICE,
    label: 'At least Purchase Price',
  },
  {
    value: CONTRACT_FINANCING_CONTINGENCY.TIMELINE,
    label: 'Timeline',
  },
];

export enum CONTRACT_FINANCING_CONTINGENCY_TYPES {
  MORTGAGE_FINANCING = 'mortgage_financing',
  SELLER_FINANCING = 'seller_financing',
  LOAN_ASSUMPTION = 'loan_assumption',
  COMMERCIAL = 'commercial',
  NOT_SELECTED = '',
}
export const contractFinancingContingencyTypes = [
  {
    value: CONTRACT_FINANCING_CONTINGENCY_TYPES.MORTGAGE_FINANCING,
    label: 'Mortgage Financing',
  },
  {
    value: CONTRACT_FINANCING_CONTINGENCY_TYPES.SELLER_FINANCING,
    label: 'Seller Financing',
  },
  {
    value: CONTRACT_FINANCING_CONTINGENCY_TYPES.LOAN_ASSUMPTION,
    label: 'Loan Assumption',
  },
  {
    value: CONTRACT_FINANCING_CONTINGENCY_TYPES.COMMERCIAL,
    label: 'Commercial',
  },
];

export enum CONTRACT_INSPECTION_CONTINGENCY {
  RESERVE_THE_RIGHT = 'reserve_the_right',
  WAIVE_THR_RIGHT = 'waive_the_right',
  SELECTED = 'selected',
  NOT_SELECTED = '',
}

export enum CONTRACT_INSPECTION_TYPE {
  ADDITIONAL_INSPECTION = 'Additional Inspection Required',
  GENERAL_INSPECTION = 'Just General Home Owners Inspection',
  NOT_SELECTED = '',
}

export enum CONTRACT_HOME_INSPECTION_CONTINGENCY {
  HOME_INSPECTION = 'home_inspection',
  SELECTED = 'selected',
  NOT_SELECTED = '',
}

export const contractInspectionTypes = [
  {
    value: CONTRACT_INSPECTION_TYPE.GENERAL_INSPECTION,
    label: 'Just General Home Owners Inspection',
  },
  {
    value: CONTRACT_INSPECTION_TYPE.ADDITIONAL_INSPECTION,
    label: 'Additional Inspection Required',
  },
];

export const contractInspectionContingencies = [
  {
    value: CONTRACT_INSPECTION_CONTINGENCY.RESERVE_THE_RIGHT,
    label: 'Reserve the right to negotiate price post inspection',
  },
  {
    value: CONTRACT_INSPECTION_CONTINGENCY.WAIVE_THR_RIGHT,
    label: 'Waive the right to negotiate price post inspection',
  },
];
export enum CONTRACT_INSPECTION_WAIVER {
  BUYER_WAIVES_RIGHT = 'buyer_waives_right',
  SELECTED = 'selected',
  NOT_SELECTED = '',
}
export const contractInspectionWaivers = [
  {
    value: CONTRACT_INSPECTION_WAIVER.BUYER_WAIVES_RIGHT,
    label: 'Buyer waives right to home inspection',
  },
];

export enum CONTRACT_POST_CLOSE_OCCUPANCY {
  YES = 'yes',
  NO = 'no',
  SELECTED = 'selected',
  NOT_SELECTED = '',
}
export const contractPostCloseOccupancies = [
  {
    value: CONTRACT_POST_CLOSE_OCCUPANCY.YES,
    label: 'Offer the buyer an option to rent the house post closing',
  },
  {
    value: CONTRACT_POST_CLOSE_OCCUPANCY.NO,
    label: 'Do not offer the buyer to rent house post closing',
  },
];

export enum CONTRACT_UNBEATABLE_CONTINGENCY {
  YES = 'yes',
  NO = 'no',
  NOT_SELECTED = '',
}
export const contractUnbeatableContingencies = [
  {
    value: CONTRACT_UNBEATABLE_CONTINGENCY.YES,
    label:
      'Unbeatable Loans LLC to receive $1,000 as contract negotiation fee.',
  },
  {
    value: CONTRACT_UNBEATABLE_CONTINGENCY.NO,
    label:
      'Seller to credit listed Buyers Agent Commission to buyer at closing, covering first the Unbeatable Loans LLC contract negotiation fee, followed by traditional closing costs.',
  },
];

export enum CONTRACT_TITLE_COMPANY_CHOICE_TIMELINE {
  RESERVED_BY_BUYER = 'reserved_by_buyer',
  WAIVE_RIGHT = 'waive_right',
  ELECT_AFFILIATED = 'elect_affiliated',
  SELECTED = 'selected',
  NOT_SELECTED = '',
}
export const contractTitleCompanyChoiceTimelines = [
  {
    value: CONTRACT_TITLE_COMPANY_CHOICE_TIMELINE.RESERVED_BY_BUYER,
    label:
      'Right to choose Title/Settlement company is reserved by buyer and will be decided on or before',
  },
  {
    value: CONTRACT_TITLE_COMPANY_CHOICE_TIMELINE.WAIVE_RIGHT,
    label: 'Buyer waives right to choose title/settlement company',
  },
  {
    value: CONTRACT_TITLE_COMPANY_CHOICE_TIMELINE.ELECT_AFFILIATED,
    label:
      'Buyer elects to prefer the settlement company affiliated with Lender and has acknowledged affiliated business relationship',
  },
];

export enum CONTRACT_TRANSFER_TAX_ELECTION {
  SELLER_PAYS_ALL = 'seller_pays_entirely',
  BUYER_PAYS_EXCESS = 'buyer_pays_entirely',
  SPLIT_BETWEEN_BUYER_AND_SELLER = 'split_equally_between_buyer_and_seller',
  SELECTED = 'selected',
  NOT_SELECTED = '',
}
export const contractTransferTaxElections = [
  {
    value: CONTRACT_TRANSFER_TAX_ELECTION.SELLER_PAYS_ALL,
    label: 'Paid entirely by seller',
  },
  {
    value: CONTRACT_TRANSFER_TAX_ELECTION.BUYER_PAYS_EXCESS,
    label: 'Paid entirely by buyer',
  },
  {
    value: CONTRACT_TRANSFER_TAX_ELECTION.SPLIT_BETWEEN_BUYER_AND_SELLER,
    label: 'Split Equally between buyer and seller',
  },
];

export enum CONTRACT_PROPERTY_CONDITION {
  AS_IS = 'As Is',
  SUBJECT = 'Subject To',
}
export const contractPropertyConditions = [
  {
    value: CONTRACT_PROPERTY_CONDITION.AS_IS,
    label: 'As Is',
  },
  {
    value: CONTRACT_PROPERTY_CONDITION.SUBJECT,
    label: 'Subject To',
  },
];

export enum CONTRACT_SUBJECT_TO {
  PERMIT_APPROVAL = 'Permit Approval',
  LOT_SURVEY = 'Lot Survey',
  REQUESTED_REPAIRS = 'Requested Repairs',
  NO_ADDITIONAL_SUBJECT_TO_CLAUSES = 'No additional Subject To Clauses',
  NOT_SELECTED = '',
}
export const contractSubjectTos = [
  {
    value: CONTRACT_SUBJECT_TO.PERMIT_APPROVAL,
    label: 'Permit Approval',
  },
  {
    value: CONTRACT_SUBJECT_TO.LOT_SURVEY,
    label: 'Lot Survey',
  },
  {
    value: CONTRACT_SUBJECT_TO.REQUESTED_REPAIRS,
    label: 'Requested Repairs',
  },
  {
    value: CONTRACT_SUBJECT_TO.NO_ADDITIONAL_SUBJECT_TO_CLAUSES,
    label: 'No additional Subject To Clauses',
  },
];

export enum CONTRACT_COPY_OF_INSPECTION {
  PROVIDE_FULL_COPY = 'provide_full_copy',
  WITHHOLD_FULL_COPY = 'withhold_full_copy',
  NOT_SELECTED = '',
}
export const contractCopyOfInspections = [
  {
    value: CONTRACT_COPY_OF_INSPECTION.PROVIDE_FULL_COPY,
    label: 'Buyer to provide a full copy of inspection to seller.',
  },
  {
    value: CONTRACT_COPY_OF_INSPECTION.WITHHOLD_FULL_COPY,
    label:
      'Buyer reserves right to withhold full copy of inspection from seller.',
  },
];

export enum CONTRACT_INSPECTION_PRESENCE_OPTION {
  BE_PRESENT = 'be_present',
  WAIVE_RIGHT = 'waive_right',
  NOT_SELECTED = '',
}
export const contractInspectionPresenceOptions = [
  {
    value: CONTRACT_INSPECTION_PRESENCE_OPTION.BE_PRESENT,
    label: 'Buyer to be present at time of inspection.',
  },
  {
    value: CONTRACT_INSPECTION_PRESENCE_OPTION.WAIVE_RIGHT,
    label: 'Buyer waives right to be present at time of inspection.',
  },
];

export enum CONTRACT_DEPOSIT_OPTION {
  DEPOSIT1 = 'deposit1',
  DEPOSIT2 = 'deposit2',
  NONE = 'none',
  NOT_SELECTED = '',
}
export const contractDepositOptions: {
  value: CONTRACT_DEPOSIT_OPTION;
  label1: string;
  label2?: string;
  name?: 'deposit1Days' | 'deposit2Days';
}[] = [
  {
    value: CONTRACT_DEPOSIT_OPTION.DEPOSIT1,
    label1: 'Deposit within ',
    label2: ' days of contract execution.',
    name: 'deposit1Days',
  },
  {
    value: CONTRACT_DEPOSIT_OPTION.DEPOSIT2,
    label1: 'Deposit 2 within ',
    label2: ' days of contract execution.',
    name: 'deposit2Days',
  },
  {
    value: CONTRACT_DEPOSIT_OPTION.NONE,
    label1: 'No Deposit',
  },
];

export enum CONTRACT_PROPERTY_TYPE {
  SINGLE_FAMILY = 'Single Family',
  MULTI_FAMILY_2_4_UNITS = 'Multi-Family 2-4 Units',
  CONDOMINIUM = 'Condominium',
  TOWNHOUSE = 'Townhouse',
  COMMERCIAL = 'Commercial',
}

export const propertyTypes = [
  {
    label: 'Single Family',
    value: CONTRACT_PROPERTY_TYPE.SINGLE_FAMILY,
  },
  {
    label: 'Multi-Family 2-4 Units',
    value: CONTRACT_PROPERTY_TYPE.MULTI_FAMILY_2_4_UNITS,
  },
  {
    label: 'Condominium',
    value: CONTRACT_PROPERTY_TYPE.CONDOMINIUM,
  },
  {
    label: 'Townhouse',
    value: CONTRACT_PROPERTY_TYPE.TOWNHOUSE,
  },
  {
    label: 'Commercial',
    value: CONTRACT_PROPERTY_TYPE.COMMERCIAL,
  },
];

export enum CONTRACT_ASSOCIATION_TYPE {
  HOA = 'Homeowners Association',
  COOP = 'Condominium Association',
  NONE = 'None',
}
export const associationTypes = [
  {
    label: 'Homeowners Association',
    value: CONTRACT_ASSOCIATION_TYPE.HOA,
  },
  {
    label: 'Condominium Association',
    value: CONTRACT_ASSOCIATION_TYPE.COOP,
  },
  {
    label: 'None',
    value: CONTRACT_ASSOCIATION_TYPE.NONE,
  },
];
// layout
export const HEADER_HEIGHT = 70;
export const HEADER_HEIGHT_ADDITIONAL = 50;
/** Second row under the main header when viewing profile routes (loan + settings tabs). */
export const PROFILE_SUBNAV_HEIGHT = 48;
export const Z_INDEX = {
  HEADER: 1400,
};

// page
export const PRODUCT_COUNT_PER_PAGE = 20;
export const PRODUCT_APPROVE_PRICE_RATIO = 0.03;

export const DEFAULT_ADMIN_ITEM_COUNT_PER_PAGE = 20;

export const S3_FOLDER = {
  DOCUMENT: 'document',
  DISCLOSURE: 'disclosure',
  PRODUCT_IMAGE: 'product-image',
};

export const states = [
  {
    label: 'Alabama',
    value: 'Alabama',
  },
  {
    label: 'Alaska',
    value: 'Alaska',
  },
  {
    label: 'Arizona',
    value: 'Arizona',
  },
  {
    label: 'Arkansas',
    value: 'Arkansas',
  },
  {
    label: 'California',
    value: 'California',
  },
  {
    label: 'Colorado',
    value: 'Colorado',
  },
  {
    label: 'Connecticut',
    value: 'Connecticut',
  },
  {
    label: 'Delaware',
    value: 'Delaware',
  },
  {
    label: 'District of Columbia',
    value: 'District of Columbia',
  },
  {
    label: 'Florida',
    value: 'Florida',
  },
  {
    label: 'Georgia',
    value: 'Georgia',
  },
  {
    label: 'Hawaii',
    value: 'Hawaii',
  },
  {
    label: 'Idaho',
    value: 'Idaho',
  },
  {
    label: 'Illinois',
    value: 'Illinois',
  },
  {
    label: 'Indiana',
    value: 'Indiana',
  },
  {
    label: 'Iowa',
    value: 'Iowa',
  },
  {
    label: 'Kansas',
    value: 'Kansas',
  },
  {
    label: 'Kentucky',
    value: 'Kentucky',
  },
  {
    label: 'Louisiana',
    value: 'Louisiana',
  },
  {
    label: 'Maine',
    value: 'Maine',
  },
  {
    label: 'Maryland',
    value: 'Maryland',
  },
  {
    label: 'Massachusetts',
    value: 'Massachusetts',
  },
  {
    label: 'Michigan',
    value: 'Michigan',
  },
  {
    label: 'Minnesota',
    value: 'Minnesota',
  },
  {
    label: 'Mississippi',
    value: 'Mississippi',
  },
  {
    label: 'Missouri',
    value: 'Missouri',
  },
  {
    label: 'Montana',
    value: 'Montana',
  },
  {
    label: 'Nebraska',
    value: 'Nebraska',
  },
  {
    label: 'Nevada',
    value: 'Nevada',
  },
  {
    label: 'New Hampshire',
    value: 'New Hampshire',
  },
  {
    label: 'New Jersey',
    value: 'New Jersey',
  },
  {
    label: 'New Mexico',
    value: 'New Mexico',
  },
  {
    label: 'New York',
    value: 'New York',
  },
  {
    label: 'North Carolina',
    value: 'North Carolina',
  },
  {
    label: 'North Dakota',
    value: 'North Dakota',
  },
  {
    label: 'Ohio',
    value: 'Ohio',
  },
  {
    label: 'Oklahoma',
    value: 'Oklahoma',
  },
  {
    label: 'Oregon',
    value: 'Oregon',
  },
  {
    label: 'Pennsylvania',
    value: 'Pennsylvania',
  },
  {
    label: 'Rhode Island',
    value: 'Rhode Island',
  },
  {
    label: 'South Carolina',
    value: 'South Carolina',
  },
  {
    label: 'South Dakota',
    value: 'South Dakota',
  },
  {
    label: 'Tennessee',
    value: 'Tennessee',
  },
  {
    label: 'Texas',
    value: 'Texas',
  },
  {
    label: 'Utah',
    value: 'Utah',
  },
  {
    label: 'Vermont',
    value: 'Vermont',
  },
  {
    label: 'Virginia',
    value: 'Virginia',
  },
  {
    label: 'Washington',
    value: 'Washington',
  },
  {
    label: 'West Virginia',
    value: 'West Virginia',
  },
  {
    label: 'Wisconsin',
    value: 'Wisconsin',
  },
  {
    label: 'Wyoming',
    value: 'Wyoming',
  },
];
